import { useUpdateSwiftlaneConnection } from '@/api/property-keyless/swiftlane/update-swiftlane-connection'

import { SwiftlaneConnectionFormValues } from './swiftlane.schema'

export const useSwiftlaneSubmit = (buildingId: number) => {
  const { mutateAsync, isPending } = useUpdateSwiftlaneConnection()

  const submit = (values: SwiftlaneConnectionFormValues) => mutateAsync({ buildingId, ...values })

  return { isPending, submit }
}
